export const OFFICE_LOCATIONS = [
  "All offices",
  "Melbourne",
  "Sydney",
  "San Francisco",
  "New York",
  "Chicago",
  "London",
  "Berlin",
  "Austin",
  "Belgrade",
]

// List of departments CULTURE AMP'S overrides in careers page (default is Greenhouse departments API response)
// Must include SubDepartments since the API response treat all as "departments"
export const CADEPARTMENTNAMES = [
  {
    greenHouseDepOrSubDepName: "Strategy & BizOps",
    caDepOrSubDepName: "Business Operations",
  },
  {
    greenHouseDepOrSubDepName: "CSSX",
    caDepOrSubDepName: "Customer Success",
  },
  {
    greenHouseDepOrSubDepName: "Data",
    caDepOrSubDepName: "Data & People Science",
  },
  {
    greenHouseDepOrSubDepName: "Data Science",
    caDepOrSubDepName: "Data & People Science",
  },
  {
    greenHouseDepOrSubDepName: "People Science",
    caDepOrSubDepName: "Data & People Science",
  },
  {
    greenHouseDepOrSubDepName: "Product Analytics",
    caDepOrSubDepName: "Data & People Science",
  },
  {
    greenHouseDepOrSubDepName: "CX - People Science",
    caDepOrSubDepName: "Data & People Science",
  },
  {
    greenHouseDepOrSubDepName: "CX - Support",
    caDepOrSubDepName: "Product Support",
  },
  {
    greenHouseDepOrSubDepName: "CS-PS",
    caDepOrSubDepName: "Data & People Science",
  },
  {
    greenHouseDepOrSubDepName: "People Science R&D",
    caDepOrSubDepName: "Data & People Science",
  },
  {
    greenHouseDepOrSubDepName: "Application Engineering",
    caDepOrSubDepName: "Engineering",
  },
  {
    greenHouseDepOrSubDepName: "Back End Engineering",
    caDepOrSubDepName: "Engineering",
  },
  {
    greenHouseDepOrSubDepName: "Data & Machine Learning Engineering",
    caDepOrSubDepName: "Engineering",
  },
  {
    greenHouseDepOrSubDepName: "Delivery Leads",
    caDepOrSubDepName: "Engineering",
  },
  {
    greenHouseDepOrSubDepName: "Front End Engineering",
    caDepOrSubDepName: "Engineering",
  },
  {
    greenHouseDepOrSubDepName: "QA",
    caDepOrSubDepName: "Engineering",
  },
  {
    greenHouseDepOrSubDepName: "Site Reliability Engineering",
    caDepOrSubDepName: "Engineering",
  },
  {
    greenHouseDepOrSubDepName: "Sales Development",
    caDepOrSubDepName: "Sales",
  },
  {
    greenHouseDepOrSubDepName: "Platform Product Marketing",
    caDepOrSubDepName: "Product Marketing",
  },
  {
    greenHouseDepOrSubDepName: "IT",
    caDepOrSubDepName: "Technology",
  },
  {
    greenHouseDepOrSubDepName: "GTM Ops",
    caDepOrSubDepName: "Revenue Operations",
  },
  {
    greenHouseDepOrSubDepName: "RevOps",
    caDepOrSubDepName: "Revenue Operations",
  },
  {
    greenHouseDepOrSubDepName: "People Experience (PX)",
    caDepOrSubDepName: "People & Experience",
  },
  {
    greenHouseDepOrSubDepName: "Security",
    caDepOrSubDepName: "Security & Risk",
  },
]
